export default __webpack_public_path__ + "static/media/sun.d07c9ece.png";